import React from 'react';
import { Typography, Card, CardContent, Box } from '@material-ui/core';

const FunnelChart = ({ stages }) => {
  const maxValue = stages[0]?.value || 1;

  return (
    <Card style={{ height: '100%' }}>
      <CardContent>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Funnel Conversion
        </Typography>
        {stages.map((stage, index) => {
          const width = (stage.value / maxValue) * 100;
          return (
            <Box key={stage.name} mb={1}>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2">{stage.name}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {stage.value}
                </Typography>
              </Box>
              <Box
                style={{
                  height: 24,
                  width: `${width}%`,
                  backgroundColor: index === 0 ? '#1976d2' : '#4caf50',
                  borderRadius: 4,
                  marginTop: 4,
                }}
              />
            </Box>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default FunnelChart;
